import loadData, { loadEShopAPi } from '../../https/loadData'
import eshopAPI from '../../api/eshopAPI'
import xyAPI from '../../api/xyAPI'
import xy_config from '../../config/xy_config'
import VueCookie from 'vue-cookie'
import { getApiToken } from '../../utils/eShopHttpUtils'
import moment from 'moment'
export default {
  state: {
    userInfo: null,
    token: null,
    maindata: null,
    maindataImgs: null,
    signinInfo: null,
    continueSign: 0,
    hasSigned: false,
    hotwordConfigs: null,
    tjzlszConfigs: null
  },
  mutations: {
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_TOKEN: (state, tokenjson) => {
      state.token = tokenjson
    },
    SET_MAINDATA: (state, maindata) => {
      state.maindata = maindata
    },
    SET_MAINDATAIMGS: (state, maindataImgs) => {
      state.maindataImgs = maindataImgs
    },
    SET_SIGNININFO: (state, signinInfo) => {
      state.signinInfo = signinInfo
    },
    SET_CONTUNUESIGN: (state, continueSign) => {
      state.continueSign = continueSign
    },
    SET_HASSIGNED: (state, hasSigned) => {
      state.hasSigned = hasSigned
    },
    SET_hotwordConfigs: (state, hotwordConfigs) => {
      state.hotwordConfigs = hotwordConfigs
    },
    SET_tjzlszConfigs: (state, tjzlszConfigs) => {
      state.tjzlszConfigs = tjzlszConfigs
    }
  },
  actions: {
    getHomeConfigByType: async ({ commit }) => {
      try {
        const kres = await loadData(xyAPI.getHomeConfigByType, { type: 'yf', levtype: 'hotword' })
        if (kres && String(kres.code) === '0') {
          commit('SET_hotwordConfigs', kres.data)
        }
        const tres = await loadData(xyAPI.getHomeConfigByType, { type: 'yf', levtype: 'tjzlsz' })
        if (tres && String(tres.code) === '0') {
          commit('SET_tjzlszConfigs', tres.data)
        }
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    getMainData: async ({ commit }) => {
      try {
        const spres = await loadEShopAPi(eshopAPI.getmaindata, { 'data[sys]': 'sp' })
        if (spres && String(spres.code) === '0') {
          commit('SET_MAINDATA', spres.data)
        }
        const yfres = await loadEShopAPi(eshopAPI.getmaindata, { 'data[sys]': 'yf' })
        if (yfres && String(yfres.code) === '0' && yfres.data && yfres.data.banners && yfres.data.banners.length > 0) {
          commit('SET_MAINDATAIMGS', yfres.data.banners)
        }
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    getSignInfo: async ({ commit }) => {
      const tokenCookie = VueCookie.get(xy_config.cookieToken)
      if (!tokenCookie) {
        return
      }
      try {
        const res = await loadData(xyAPI.getUserSigninInfo, {})
        if (res && String(res.code) === '0') {
          // 是不是当天的
          const nowDate = moment()
            .hour(0)
            .minute(0)
            .second(0)
            .millisecond(0)
          const lastDate = moment(res.data.last_signin_time)
            .hour(0)
            .minute(0)
            .second(0)
            .millisecond(0)
          if (nowDate.diff(lastDate, 'days') === 0) {
            commit('SET_CONTUNUESIGN', res.data.cont_singin_days)
            commit('SET_HASSIGNED', true)
          } else if (nowDate.diff(lastDate, 'days') === 1) {
            commit('SET_CONTUNUESIGN', res.data.cont_singin_days)
          } else {
            commit('SET_CONTUNUESIGN', 0)
          }
          commit('SET_SIGNININFO', res.data)
        }
      // eslint-disable-next-line no-empty
      } catch (error) {
      }
    },
    getUserInfo: async ({ commit }) => {
      const tokenCookie = VueCookie.get(xy_config.cookieToken)
      if (!tokenCookie) {
        return
      } else {
        commit('SET_USERINFO', null)
        commit('SET_TOKEN', null)
      }
      const mParam = {}
      const tokenJSON = JSON.parse(tokenCookie)
      commit('SET_TOKEN', tokenJSON)
      const ts = new Date().getTime()
      mParam['ts'] = ts
      mParam['client_id'] = xy_config.client_id
      mParam['api_token'] = getApiToken(xy_config.client_id, eshopAPI.getuser, ts)
      mParam['user_id'] = tokenJSON.user_id
      mParam['user_token'] = tokenJSON.user_token
      mParam['data[user_id]'] = tokenJSON.user_id
      const res = await loadData(eshopAPI.getuser, mParam)
      if (String(res.code === '0')) {
        commit('SET_USERINFO', res.data)
      }
    }
  }
}
